import type { QueryClient } from "@tanstack/react-query";
import { prefetchKnowledgeBaseItem } from "@/queries/knowledgeBaseDocuments";

const hoverTimers = new Map<string, ReturnType<typeof setTimeout>>();

/** Debounced prefetch of full document for list hover/focus. */
export function schedulePrefetchKnowledgeBaseItem(
  queryClient: QueryClient,
  id: string,
  delayMs = 150
): void {
  const existing = hoverTimers.get(id);
  if (existing) clearTimeout(existing);
  hoverTimers.set(
    id,
    setTimeout(() => {
      hoverTimers.delete(id);
      void prefetchKnowledgeBaseItem(queryClient, id);
    }, delayMs)
  );
}
